const error_codes: Record<string, any> = {
    "12": "Invalid Account - SSA/TD",
    "13": "Below minimum amount",
    "24": "Transaction not supported",
    "25": "Invalid Account / No Record",
    "61": "Receiving Financial Institution exceeds amount limit",
    "62": "Account is closed, blocked, dormant or inactive",
    "68": "Processing by receiver bank",
    "76": "Receiver bank timed-out",
    "78": "Invalid bank code",
    "79": "Invalid business date",
    "82": "Receiver bank unreachable",
    "90": "Error, receiver bank cutoff processing",
    "96": "Receiver bank unreachable",
    "77": "Receiver bank error",
    "15": "Invalid transferee bank",
    "19": "Cannot connect to server. Please try again later.",
    "30": "Invalid message content",
    "70": "Receiving Financial Institution offline",
    "91": "Receiving financial institution : Service Unavailable",
    "99": "Duplicate transaction",
    "101": "No Issuer Bank code",
    "102": "Cannot connect to Please try again later.",
    "103": "Cannot connect to Please try again later.",
    "104": "Cannot connect to Please try again later.",
    "105": "No Sender Account Name",
    "106": "No Sender Account Number",
    "107": "No Account Type",
    "108": "Cannot connect to server. Please try again later.",
    "109": "No Receivin Financial Institution code",
    "110": "No Receiver Account Name",
    "111": "No Receiver Name",
    "112": "No Transaction Amount",
    "113": "Cannot connect to server. Please try again later.",
    "114": "Cannot connect to server. Please try again later.",
    "115": "Cannot connect to server. Please try again later.",
    "116": "Cannot connect to server. Please try again later.",
    "117": "Cannot connect to server. Please try again later.",
    "118": "Cannot connect to server. Please try again later.",
    "119": "Cannot connect to server. Please try again later.",
    "120": "Cannot connect to server. Please try again later.",
    "121": "Cannot connect to server. Please try again later.",
    "122": "Cannot connect to server. Please try again later.",
    "123": "Cannot connect to server. Please try again later.",
    "124": "Invalid Account Name",
    "125": "Invalid Account No",
    "126": "Invalid Account Type",
    "127": "lnvalid Account Id",
    "128": "Invalid Transferee Bank Code",
    "129": "Invalid Receiving Financial Institution Account Number",
    "130": "Invalid amount",
    "132": "Cannot connect to server. Please try again later.",
    "133": "Cannot connect to server. Please try again later.",
    "134": "Cannot connect to server. Please try again later.",
    "135": "Cannot connect to server. Please try again later.",
    "136": "Invalid Param1",
    "137": "Invalid Param2",
    "138": "Invalid Param3",
    "139": "Invalid Customer No",
    "140": "Invalid Purpose",
    "141": "Cannot connect to server. Please try again later.",
    "142": "Duplicate transaction",
    "143": "Below Minimum Amount",
    "144": "Amount Limit Exceeded",
    "145": "Transaction Amount Limit",
    "146": "Bank not allowed Receiving Financial Institution for instapay",
    "147": "Invalid transaction",
    "151": "Cannot connect to server. Please try again later.",
    "998": "No record found for IBFT Credit",
    "999": "Receiving Bank is Offline. Please try again later",
    "AB01": "AbortedCIearingTimeout",
    "AB02": "AbortedClearingFataIError",
    "AB03": "AbortedSettlementTimeout",
    "AB04": "AbortedSettlementFatalError",
    "AB05": "Tim e outCreditor Agent",
    "AB06": "TimeoutInstructedAgent",
    "AB07": "Offline Agent",
    "AB08": "Offline Creditor Agent",
    "AB09": "ErrorCreditorAgent",
    "AB10": "ErrorlnstructedAgent",
    "AC01": "IncorrectAccountNumber",
    "AC02": "InvalidDebtorAccountNumber",
    "AC03": "InvalidCreditorAccountNumber",
    "AC04": "ClosedAccountNumber",
    "AC05": "ClosedDebtorAccountNumber",
    "AC06": "BlockedAccount",
    "ACO7": "ClosedCreditorAccountNumber",
    "AC08": "InvalidBranchCode",
    "AC09": "InvalidAccountCurrency",
    "AC10": "InvalidDebtorAccountCurrency",
    "AC11": "InvalidCreditorAccountCurrency",
    "AC12": "InvalidAccountType",
    "AC13": "InvalidDebtorAccountType",
    "AC14": "InvalidCreditorAccountType",
    "AC15": "AccountDetailsChanged",
    "AG01": "TransactionForbidden",
    "AG02": "InvalidBankOperationCode",
    "AG03": "TransactionNotSupported",
    "AG04": "InvalidAgentCountry",
    "AG05": "InvalidDebtorAgentCountry",
    "AG06": "InvalidCreditorAgentCountry",
    "AG07": "UnsuccesfulDirectDebit",
    "AG08": "InvalidAccessRights",
    "AG09": "PaymentNotReceived",
    "AG10": "AgentSuspended",
    "AG11": "CreditorAgentSuspended",
    "AGNT": "IncorrectAgent",
    "AM01": "ZeroAmount",
    "AM02": "NotAllowedAmount",
    "AM03": "NotAllowedCurrency",
    "AM04": "InsufficientFunds",
    "AM05": "Duplication",
    "AM06": "TooLowAmount",
    "AM07": "BlockedAmount",
    "AM09": "WrongAmount",
    "AM10": "InvalidControlSum",
    "AM11": "InvalidTransactionCurrency",
    "AM12": "InvalidAmount",
    "AM13": "AmountExceedsClearingSystemLimit",
    "AM14": "AmountExceedsAgreedLimit",
    "AM15": "AmountBelowClearingSystemMinimum",
    "AM16": "InvalidGroupControlSum",
    "AM17": "InvalidPaymentlnfoControlSum",
    "AM18": "InvalidNumberOfTransactions",
    "AM19": "InvalidGroupNumberOfTransactions",
    "AM20": "InvalidPaymentlnfoNumberOfTransactions",
    "AM21": "LimitExceeded",
    "AM22": "ZeroAmountNotApplied",
    "AM23": "AmountExceedsSettlementLimit",
    "BE01": "InconsistentWithEndCustomer",
    "BE04": "MissingCreditorAddress",
    "BE05": "UnrecognisedlnitiatingParty",
    "BE06": "UnknownEndCustomer",
    "BE07": "MissingDebtorAddress",
    "BE08": "MissingDebtorName",
    "BE09": "InvalidCountry",
    "BE10": "InvalidDebtorCountry",
    "BE11": "InvalidCreditorCountry",
    "BE12": "InvalidCountryOfResidence",
    "BE13": "InvalidDebtorCountryOfResidence",
    "BE14": "InvalidCreditorCountryOfResidence",
    "BE15": "InvalidldentificationCode",
    "BE16": "InvalidDebtorldentificationCode",
    "BE17": "InvalidCreditorldentificationCode",
    "BE18": "InvalidContactDetails",
    "BE19": "InvalidChargeBearerCode",
    "BE20": "InvalidNameLength",
    "BE21": "MissingName",
    "BE22": "MissingCreditorName",
    "CERI": "CheckERl",
    "CH03": "RequestedExecutionDateOrRequestedCollectio nDateToo FarlnFuture",
    "CH04": "RequestedExecutionDateOrRequestedCollectionDateTooFarlnPast",
    "CH07": "ElementlsNotToBeUsedAtB-andC-Level",
    "CH09": "MandateChangesNotAllowed",
    "CH10": "InformationOnMandateChangesMissing",
    "CH11": "Creditorldentifierlncorrect",
    "CH12": "CreditorldentifierNotUnambiguouslyAtTransaction-Level",
    "CH13": "OriginalDebtorAccountlsNotToBeUsed",
    "CH14": "OriginalDebtorAgentlsNotToBeUsed",
    "CH15": "ElementContentlncludesMoreThan140Characters",
    "CH16": "ElementContentFormallylncorrect",
    "CH17": "ElementNotAdmitted",
    "CH19": "ValuesWillBeSetToNextTARGETday",
    "CH20": "DecimalPointsNotCompatibleWithCurrency",
    "CH21": "RequiredCompulsoryElementMissing",
    "CH22": "COREandB2BwithinOnemessage",
    "CNOR": "Creditor bank is not registered",
    "CURR": "IncorrectCurrency",
    "CUS": "equestedByCustomer",
    "DNOR": "Debtor bank is not registered",
    "DS01": "ElectronicSignaturesCorrect",
    "DS02": "OrderCancelled",
    "DS03": "OrderNotCancelled",
    "DS04": "OrderRejected",
    "DS05": "OrderForwardedForPostprocessing",
    "DS06": "TransferOrder",
    "DS07": "ProcessingOK",
    "DS08": "DecompressionError",
    "DS09": "DecryptionError",
    "DSOA": "DataSignRequested",
    "DS0B": "UnknownDataSignFormat",
    "DSOC": "SignerCertificateRevoked",
    "DSOD": "SignerCertificateNotValid",
    "DSOE": "IncorrectSignerCertificate",
    "DSOF": "SignerCertificationAuthoritySignerNotValid",
    "DSOG": "NotAllowedPayment",
    "DSOH": "NotAllowedAccount",
    "DSOK": "NotAllowedNumberOfTransaction",
    "DS10": "Signer1CertificateRevoked",
    "DS11": "Signer1CertificateNotValid",
    "DS12": "IncorrectSigner1Certificate",
    "DS13": "SignerCertificationAuthoritySigner1NotValid",
    "DS14": "UserDoesNotExist",
    "DS15": "IdenticalSignatureFound",
    "DS16": "PublicKeyVersionlncorrect",
    "DS17": "DifferentOrderDatalnSignatures",
    "DS18": "RepeatOrder",
    "DS19": "ElectronicSignatureRightslnsufficient",
    "DS20": "Signer2CertificateRevoked",
    "DS21": "Signer2CertificateNotValid",
    "DS22": "IncorrectSigner2Certificate",
    "DS23": "SignerCertificationAuthoritySigner2NotValid",
    "DS24": "WaitingTimeExpired",
    "DS25": "OrderFileDeleted",
    "DS26": "UserSignedMultipleTimes",
    "DS27": "UserNotYetActivated",
    "DT01": "InvalidDate",
    "DT02": "InvalidCreationDate",
    "DT03": "InvalidNonProcessingDate",
    "DT04": "FutureDateNotSupported",
    "DT05": "InvalidCutOffDate",
    "DT06": "ExecutionDateChanged",
    "DU01": "DuplicateMessagelD",
    "DU02": "DuplicatePaymentlnformationlD",
    "DU03": "DuplicateTransaction",
    "DU04": "DuplicateEndToEndlD",
    "DU05": "DuplicatelnstructionlD",
    "DUPL": "DuplicatePayment",
    "ED01": "CorrespondentBankNotPossible",
    "ED03": "BalancelnfoRequest",
    "ED05": "SettlementFailed",
    "ED06": "SettlementSystemNotAvailable",
    "ERIN": "ERIOptionNotSupported",
    "FF01": "Invalid File Format",
    "FF02": "SyntaxError",
    "FF03": "InvalidPaymentTypelnformation",
    "FF04": "InvalidServiceLevelCode",
    "FF05": "InvalidLocallnstrumentCode",
    "FF06": "InvalidCategoryPurposeCode",
    "FF07": "InvalidPurpose",
    "FF08": "InvalidEndToEndld",
    "FF09": "InvalidChequeNumber",
    "FF10": "BankSystemProcessingError",
    "FF11": "ClearingRequestAborted",
    "G000": "Payment transferred and not tracked",
    "G001": "CreditDebitNotConfirmed",
    "G002": "CreditDebitNotConfirmed",
    "G003": "CreditPendingDocuments",
    "G004": "CreditPendingFunds",
    "G005": "DeliveredWithServiceLevel",
    "G006": "DeliveredWlthoutServiceLevel",
    "ID01": "CorrespondingOriginalFileStillNotSent",
    "MD01": "NoMandate",
    "MD02": "MissingMandatorylnformationln Mandate",
    "MD05": "CollectionNotDue",
    "MD06": "RefundRequestByEndCustomer",
    "MD07": "EndCustomerDeceased",
    "MS02": "NotSpecifiedReasonCustomer Generated",
    "MS03": "NotSpecifiedReasonAgent Generated",
    "NARR": "Narrative",
    "NERI": "NoERl",
    "RC01": "Bankldentifierlncorrect",
    "RC02": "InvalidBankldentifier",
    "RC03": "InvalidDebtorBankldentifier",
    "RC04": "InvalidCreditorBankldentifier",
    "RC05": "InvalidBlCldentifier",
    "RC06": "InvalidDebtorBlCldentifier",
    "RC07": "InvalidCreditorBlCldentifier",
    "RC08": "InvalidClearingSystemMemberldentifier",
    "RC09": "Invalid DebtorClearingSystemMemberldentifier",
    "RC10": "InvalidCreditorClearingSystemMemberldentifier",
    "RC11": "InvalidlntermediaryAgent",
    "RC12": "MissingCreditorSchemeld",
    "RCON": "R-MessageConflict",
    "RF01": "NotUniqueTransactionReference",
    "RR01": "Missing Debtor Account or Identification",
    "RR02": "Missing Debtor Name or Address",
    "RR03": "Missing Creditor Name or Address",
    "RR04": "RegulatoryReason",
    "RR05": "Regulatorylnformationlnvalid",
    "RR06": "Taxlnformationlnvalid",
    "RR07": "Remittancelnformationlnvalid",
    "RR08": "RemittancelnformationTruncated",
    "RR09": "InvalidStructuredCreditorReference",
    "RR10": "InvalidCharacterSet",
    "RR11": "InvalidDebtorAgentServicelD",
    "RR12": "InvalidPartylD",
    "sooo": "ValidRequestForCancellationAcknowledged",
    "S001": "UETRFlaggedForCancellation",
    "S002": "NetworkStopOfUETR",
    "S003": "RequestForCanacellationForwarded",
    "S004": "RequestForCancellationDeliveryAcknowledgement",
    "SL01": "Specific Service offered by Debtor Agent",
    "SL02": "Specific Service offered by Creditor Agent",
    "SL11": "Creditor not on Whitelist of Debtor",
    "SL12": "Creditor on Blacklist of Debtor",
    "SL13": "Maximum number of Direct Debit Transactions exceeded",
    "SL14": "Maximum Direct Debit Transaction Amount exceeded",
    "TA01": "TransmissonAborted",
    "TD01": "NoDataAvailable",
    "TD02": "FileNonReadable",
    "TD03": "IncorrectFileStructure",
    "TM01": "InvalidCutOffTime Formerly: CutOffTime",
    "TS01": "TransmissionSuccessful",
    "TS04": "TransferToSignByHand"
}

export default error_codes;